import { CONTACT_EMAIL } from '@/constants/contact'
import { DEVELOPER_CREDITS } from '@/constants/developer-credits'
import { CATEGORY_LABELS } from '@/constants/products'
import { STORE_INFO } from '@/constants/store-info'
import { productCategorySchema } from '@/schemas/product.schema'

export interface FooterNavLink {
  label: string
  href: string
}

const CATEGORY_LINKS: FooterNavLink[] = productCategorySchema.options.map(
  (category) => ({
    label: CATEGORY_LABELS[category],
    href: `/catalogo/${category}`,
  }),
)

const NAVIGATION_LINKS: FooterNavLink[] = [
  ...CATEGORY_LINKS,
  { label: 'Sobre', href: '/sobre' },
]

export function useFooterModel() {
  return {
    storeInfo: STORE_INFO,
    developerCredits: DEVELOPER_CREDITS,
    navigationLinks: NAVIGATION_LINKS,
    contactEmail: CONTACT_EMAIL,
    contactEmailHref: `mailto:${CONTACT_EMAIL}`,
    deliveryLine: `Entrega em ${STORE_INFO.deliveryArea}`,
    currentYear: new Date().getFullYear(),
  }
}
